<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>format_list_bulleted</mat-icon>
        <div>Historico de Categorias</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <a mat-button (click)="exportToCSV()" style='width:60px; '>
          <mat-icon color='primary'>arrow_circle_down</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card style="height: calc(100vh - 180px); overflow: auto;">

    <div *ngFor="let itens of arrayCategory; let line = index" style="display: flex; flex-direction: row;">

      <div id=line *ngFor="let item of itens; let i = index" style="height: 26px;  border-bottom: solid 1px silver; margin-bottom: 5px;">
        <div *ngIf="i == 0" style="width: 340px;">{{item}}</div>
        <div *ngIf="i != 0" style="width: 240px; display: flex; justify-content: center;">{{item}}</div>
      </div>

    </div>

  </mat-card>

</div>